const ControlButtons = ({ saveButtonClick, cancelButtonClick}) => {
	const btnClass = `btn btn-round bg-transparent h-[24px] min-h-0 min-w-0 p-0 font-MaterialIcons text-xl font-normal border-normal hover:-translate-y-0.5 px-2`

	return (
		<div className="flex items-center gap-2 justify-end">
			<button className={`
				${btnClass}
				border-primary text-primary hover:bg-primary hover:text-white
			`}

				onClick={() => {
					saveButtonClick()
				}}
			>
				check
			</button>
			<button className={`
				${btnClass}
				border-danger text-danger hover:bg-danger hover:text-white
			`}

				onClick={() => {
					cancelButtonClick()
				}}
			>
				close
			</button>
		</div >
	)
}

export default ControlButtons